import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Flex, Select } from 'antd';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { DATE_FORMAT } from '../../constants/common';

import { setCurrentSelectedDay } from '../../redux/actions/calendar';

import styles from './styles.module.scss';

import PrevNextButtons from '../PrevNextButtons';
import { CALENDAR_VIEWS, TOOLBAR_OPTIONS } from './constants';

dayjs.extend(utc);

function CustomToolbar(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  const calendarState = useSelector(state => state.calendar);
  const { currentSelectedDate } = useSelector(state => state.calendar);

  const goToBack = () => {
    const newDate = dayjs(currentSelectedDate).utc().startOf('day');
    let updatedDate;

    switch (props.currentView) {
      case CALENDAR_VIEWS.YEAR:
        updatedDate = newDate.subtract(1, 'y');
        break;
      case CALENDAR_VIEWS.MONTH:
        updatedDate = newDate.subtract(1, 'M');
        break;
      case CALENDAR_VIEWS.WEEK:
        updatedDate = newDate.subtract(1, 'w');
        break;
      default:
        updatedDate = newDate.subtract(1, 'd');
    }

    props.onNavigate(updatedDate.toDate(), props.currentView);
    dispatch(setCurrentSelectedDay(updatedDate.toISOString()));
  };

  const goToNext = () => {
    const newDate = dayjs(currentSelectedDate).utc().startOf('day');
    let updatedDate;

    switch (props.currentView) {
      case CALENDAR_VIEWS.YEAR:
        updatedDate = newDate.add(1, 'y');
        break;
      case CALENDAR_VIEWS.MONTH:
        updatedDate = newDate.add(1, 'M');
        break;
      case CALENDAR_VIEWS.WEEK:
        updatedDate = newDate.add(1, 'w');
        break;
      default:
        updatedDate = newDate.add(1, 'd');
    }

    props.onNavigate(updatedDate.toDate(), props.currentView);
    dispatch(setCurrentSelectedDay(updatedDate.toISOString()));
  };

  useEffect(() => {
    if (calendarState.prevCount) {
      goToBack();
    }
  }, [calendarState.prevCount]);

  useEffect(() => {
    if (calendarState.nextCount) {
      goToNext();
    }
  }, [calendarState.nextCount]);

  const goToDayView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(props.selectedCalendarDate || today.toISOString()));
    props.onView(CALENDAR_VIEWS.DAY);
    props.handleViewChange(CALENDAR_VIEWS.DAY);
  };

  const goToWeekView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.onView(CALENDAR_VIEWS.WEEK);
    props.handleViewChange(CALENDAR_VIEWS.WEEK);
  };

  const goToMonthView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.onView(CALENDAR_VIEWS.MONTH);
    props.handleViewChange(CALENDAR_VIEWS.MONTH);
  };

  const goToYearView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.onView(CALENDAR_VIEWS.YEAR);
    props.handleViewChange(CALENDAR_VIEWS.YEAR);
  };

  const goToAgendaView = () => {
    props.onView('customAgenda');
    props.handleViewChange('customAgenda');
  };

  const goToToday = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.date?.setMonth(today.getMonth());
    props.date?.setYear(today.getFullYear());
    props.date?.setDate(today.getDate());
    props.onNavigate(today);
  };

  const month = () => {
    const date = dayjs(currentSelectedDate);

    return <p className={styles.month}>{date.format(DATE_FORMAT.DATE_MONTH_YEAR)}</p>;
  };

  const handleChange = value => {
    props.handleViewChange(value === 'today' ? CALENDAR_VIEWS.DAY : value);
    switch (value) {
      case 'today':
        return goToToday();
      case CALENDAR_VIEWS.DAY:
        return goToDayView();
      case CALENDAR_VIEWS.WEEK:
        return goToWeekView();
      case CALENDAR_VIEWS.MONTH:
        return goToMonthView();
      case CALENDAR_VIEWS.YEAR:
        return goToYearView();
      case 'customAgenda':
        return goToAgendaView();
    }
  };

  const options = [
    {
      label: 'Today',
      value: 'today',
      disabled: dayjs(currentSelectedDate).isSame(dayjs(), 'day')
    },
    ...TOOLBAR_OPTIONS
  ].filter(option => (props.excludeEventList ? option.value !== 'customAgenda' : true));

  return (
    <Flex align="center" justify="space-between" gap="small" className="mb-2 w-full" wrap>
      {month()}

      <Flex gap="small">
        {location.pathname !== '/dashboard' && (
          <Select
            className="calendar-select"
            size="large"
            value={props.currentView ?? CALENDAR_VIEWS.WEEK}
            options={options}
            onChange={handleChange}
          />
        )}
        <PrevNextButtons nextId={true} prevId={true} handlePrev={goToBack} handleNext={goToNext} />
      </Flex>
    </Flex>
  );
}

export default CustomToolbar;
